export default __webpack_public_path__ + "static/media/ic_cross.c6007472.svg";